export default {
  props: {
    formIdentifier: {
      required: true,
      type: String
    }
  },

  mounted () {
    this.$watch(() => this.$v.$anyDirty, value => {
      this.$store.dispatch(value ? 'addOrUpdateForm' : 'removeForm', this.formIdentifier)
    })
  }
}
